import storage from "../storage"
import {GrowthBook} from "@growthbook/growthbook"
import {
  autoAttributesPlugin,
  growthbookTrackingPlugin
} from "@growthbook/growthbook/plugins"
import {genUUID} from "../helper"

function initGrowthBook() {
  window.gb = new GrowthBook({
    apiHost: "https://cdn.growthbook.io",
    clientKey: window.gon.growthbookClientKey,
    enableDevMode: window.gon.railsEnv !== "production",
    plugins: [
      autoAttributesPlugin({
        // we need to manage it with localstorage so it doesn't get saved
        // to as as cookie
        uuid: getDeviceId(),
        uuidKey: "device_id",
        // this disable cookie usage, because we want to use localstorage
        uuidAutoPersist: false
      }),
      growthbookTrackingPlugin()
    ].filter(Boolean),
    attributes: {
      // eslint-disable-next-line camelcase
      user_id: window.gon.currentUser?.userId,
      country: window.gon.geoipCountry,
      locale: window.gon.locale,
      environment: window.gon.railsEnv
    }
  })

  // Wait for features to be available
  window.gb.initSync({payload})
}

const developmentPayload = {
  features: {
    // eslint-disable-next-line camelcase
    trust_copy_on_header: {
      defaultValue: true,
      rules: [
        {
          id: "fr_19g623mf2awtoq",
          condition: {
            $or: [
              {environment: "development"},
              {environment: "staging"}
            ]
          },
          coverage: 1,
          hashAttribute: "device_id",
          seed: "6d949dcb-4870-41d0-bd41-104593443a91",
          hashVersion: 2,
          variations: [true, false],
          weights: [0.5, 0.5],
          key: "trust-copy-header",
          meta: [
            {key: "0", name: "Original"},
            {key: "1", name: "Variation"}
          ],
          phase: "1",
          name: "Trust copy on header"
        }
      ]
    }
  },
  experiments: []
}

const productionPayload = {
  features: {
    // eslint-disable-next-line camelcase
    trust_copy_on_header_production: {
      defaultValue: true,
      rules: [
        {
          id: "fr_19g62amf3psybs",
          coverage: 1,
          hashAttribute: "device_id",
          seed: "6d949dcb-4870-41d0-bd41-104593443a91",
          hashVersion: 2,
          variations: [true, false],
          weights: [0.5, 0.5],
          key: "trust-copy-header-production",
          meta: [
            {key: "0", name: "Original"},
            {key: "1", name: "Variation"}
          ],
          phase: "0",
          name: "Trust copy on header"
        }
      ]
    }
  },
  experiments: []
}

const payload = window.gon.railsEnv === "production" ?
  productionPayload :
  developmentPayload

function getDeviceId() {
  let uuid =  storage.get("gb_uuid")
  if (uuid) return uuid

  uuid = genUUID()
  storage.set("gb_uuid", uuid)
  return uuid
}

export default initGrowthBook
